// @flow

import GeoJSONSvg from './GeoJSONSvg'

export default GeoJSONSvg
